<template>
    <div class="part">
    <el-container style="height:100%;">
      <el-header class="headers flex">
      <GlobalHeader></GlobalHeader>
      </el-header>
       <el-container>
            <el-aside width="260px"><Sidebar></Sidebar></el-aside>
            <el-main>
                <router-view></router-view>
            </el-main>
        </el-container>
    </el-container>
        
     
    </div>
</template>

<script>
import GlobalHeader from '@/components/GlobalHeader/GlobalHeader'
import Sidebar from '@/components/GlobalAside/index.vue'
export default {
  name: 'ManageView',
  components: {
    GlobalHeader,
    Sidebar,
  },
}
</script>

<style scoped>
.headers{padding:0;}
.part{height: 100%;}
</style>